<style>
    .card .card-content .card-title {
        margin: 20px 0 20px 0 !important;
    }

    .text-center-important {
        text-align: center
    }

    .main-number {
        font-weight: bold
    }

    .right {
        float: right;
        font-size: 12px
    }

    .ct-label.ct-horizontal.ct-end {
        transform: rotate(-70deg);
        margin-top: 6px;
        margin-left: -19px;
    }
</style>
<div class="main-content" *ngIf="!adminMetric">
    <div class="loader"></div>
</div>
<div class="main-content" *ngIf="adminMetric">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card chart-container">
                    <div class="card-header">
                        <h4 class="card-title chart-card-title">Logs</h4>
                        <p class="category">Exibe número de transações totais e transações com doação.
                            Última atualização: {{ lastUpdateDate | date:'dd/MM/yyyy hh:mm' : 'UTC 0'}}</p>
                    </div>
                    <div class="card-content">
                        <div id="chartLogs"></div>
                        <div class="row flex-chart-container">
                            <div class="legend-chart">
                                <div class="legend-box-color section-original"></div>
                                <span>Transações.</span>
                            </div>
                            <div class="legend-chart">
                                <div class="legend-box-color section-polen"></div>
                                <span>Compras.</span>
                            </div>
                            <div class="legend-chart">
                                <div class="legend-box-color section-polen"
                                    style="background-color: #D20025 !important"></div>
                                <span>Erros.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card chart-container">
                    <div class="card-header">
                        <h4 class="card-title chart-card-title">Compras</h4>
                        <p class="category">Exibe número de compras totais.</p>
                    </div>
                    <div class="card-content">
                        <div id="chartPurchases"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-content">
                        <h4 class="card-title">Compras</h4>
                        <div class="toolbar">
                            <!--        Here you can write extra buttons/actions for the toolbar              -->
                        </div>
                        <div class="fresh-table">
                            <table id="transactions" class="table table-striped table-no-bordered table-hover"
                                cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Data</th>
                                        <th>Loja</th>
                                        <th>OrderId</th>
                                        <th>Produtos</th>
                                        <th>Ong apoiada</th>
                                        <th>Valor da compra</th>
                                        <th>Doação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of adminMetric.lastTransactions">
                                        <td>{{row.dateStarted | date:'dd/MM/yy hh:mm:ss'}}</td>
                                        <td>{{row.pageUrl}}</td>
                                        <td>{{row.orderId}}</td>
                                        <td>{{row.products?.length}}</td>
                                        <td>{{row.ngoUrl}}</td>
                                        <td>R$ {{row.totalPrice | number: '2.2-2'}}</td>
                                        <td>R$ {{row.donation | number: '2.2-2'}}</td>
                                        <td class="td-actions text-right">
                                            <a href="https://storeapi.opolen.com.br/Api/FixError/FixTotalPrice?orderId={{row.orderId}}&pageUrl={{row.pageUrl}}"
                                                target="_blank" class="btn btn-sm">Corrigir Valor</a>&nbsp;
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>